import { Accordion } from '../../../../../components/general/accordion';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import { Grid } from '@mui/material';
import FieldText from '../../../../../components/general/fields/fieldText';
import { PqrReconsiderationProps } from './props';
import { usePqrReconsideration } from './hook';

export const PqrReconsideration = ({
    reconsideration,
}: PqrReconsiderationProps) => {
    const { formik } = usePqrReconsideration(reconsideration);

    return (
        <Accordion
            title="RECONSIDERACIÓN"
            icon={<ThumbUpIcon sx={{ color: 'primary.main' }} />}
            defaultExpanded={false}
            mt={0}
        >
            <Grid
                container
                spacing={{ xs: 1.5, md: 1.5 }}
                columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            >
                <Grid item xs={12} sm={6}>
                    <FieldText
                        label="Reconcideración"
                        name="replica"
                        size="small"
                        value={formik.values.replica}
                    />
                </Grid>
            </Grid>
        </Accordion>
    );
};
